import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

const POEditRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const purchaseOrder = location.state.data;
    const { useFetch } = useAPIQuery({
        key: `purchase-order-${purchaseOrder?.id}`,
        endpoint: `/api/purchase-order/${purchaseOrder?.id}`,
    });

    const po = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
        enabled: !!purchaseOrder?.id,
    });
    useEffect(() => {
        if (po.data) {
            setTimeout(() => {
                navigate(`/edit-purchase-order`, {
                    state: { data: po.data?.results?.data },
                    replace: true,
                });
            }, 1000);
        } else if (!po.data && po.isError) {
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 1000);
        }
    }, [po.data, po.isError]);
    if (po.isLoading) return <div>Loading...</div>;
    if (po.data) return <div>redirecting...</div>;
    if (po.isError) return <div>Failed to load</div>;
    return <div>Error</div>;
};

export default POEditRedirect;
